import { Text } from "components/core/Text";
import { ComponentProps } from "react";

export const ContentAuthorName = (
    props: Omit<ComponentProps<typeof Text>, "variant">
) => {
    return <Text variant="body4" color="text.primary" {...props} />;
};
